module.exports = __webpack_public_path__ + "static/media/bg-3.56e5e08c.jpg";